module.exports = __webpack_public_path__ + "assets/img/img172.d7427add.png";